import React from "react";
import UserAdmin from "./User&Admin/userDanAdmin";
import AspirasiBeranda from "./aspirasiBeranda/aspirasiBeranda";
import VoteBeranda from "./voteBeranda/voteBeranda";

const Beranda = () => {
  return (
    <div className="p-3">
      <div className="flex justify-start font-bold text-2xl">Dashboard</div>
      <div className="mt-3">
        <UserAdmin />
      </div>
      <div className="mt-5">
        <AspirasiBeranda />
      </div>

      <div className="mt-5">
        <VoteBeranda />
      </div>
    </div>
  );
};

export default Beranda;
